<template>
  <div class="c-match-handicap morebetcs" :id="'cmatch'+event.eveid">
    <div class="vrow no-wrap">
      <!-- FT CS  -->
      <div class="handicap-col">
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 0</div>
            </div>
            <cstgftht :event="event" :score="'od10'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod10" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 0</div>
            </div>
            <cstgftht :event="event" :score="'od20'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod20" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 1</div>
            </div>
            <cstgftht :event="event" :score="'od21'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod21" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 0</div>
            </div>
            <cstgftht :event="event" :score="'od30'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod30" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;"><span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 1</div>
            </div>
            <cstgftht :event="event" :score="'od31'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod31" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 2</div>
            </div>
            <cstgftht :event="event" :score="'od32'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod32" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">4 - 0</div>
            </div>
            <cstgftht :event="event" :score="'od40'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod40" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">4 - 1</div>
            </div>
            <cstgftht :event="event" :score="'od41'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod41" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">4 - 2</div>
            </div>
            <cstgftht :event="event" :score="'od42'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod42" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">4 - 3</div>
            </div>
            <cstgftht :event="event" :score="'od43'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod43" />
          </div>
        </div>
        <div class="bet-item-wrap col3 absolute" style="height: 35px !important;" :style="{ width: (widthColumn[1]*3) + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">{{ sportAllBetLang['ALL_BET.LBL_AOS'] }}</div>
            </div>
            <cstgftht :event="event" :score="'aos'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamodaos" />
          </div>
        </div>
      </div>
      <div class="handicap-col">
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 0</div>
            </div>
            <cstgftht :event="event" :score="'od00'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod00" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 1</div>
            </div>
            <cstgftht :event="event" :score="'od11'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod11" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 2</div>
            </div>
            <cstgftht :event="event" :score="'od22'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod22" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 3</div>
            </div>
            <cstgftht :event="event" :score="'od33'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod33" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">4 - 4</div>
            </div>
            <cstgftht :event="event" :score="'od44'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod44" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap visibility" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </div>
      <div class="handicap-col">
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 1</div>
            </div>
            <cstgftht :event="event" :score="'od01'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod01" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 2</div>
            </div>

            <cstgftht :event="event" :score="'od02'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod02" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 2</div>
            </div>

            <cstgftht :event="event" :score="'od12'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod12" />

          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od03'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod03" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od13'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod13" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od23'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod23" />

          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 4</div>
            </div>

            <cstgftht :event="event" :score="'od04'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod04" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 4</div>
            </div>

            <cstgftht :event="event" :score="'od14'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod14" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 4</div>
            </div>

            <cstgftht :event="event" :score="'od24'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod24" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+ftPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 4</div>
            </div>

            <cstgftht :event="event" :score="'od34'" :plyType="ftPlyType" :betType="bettype" :decimalNumber="1" ref="teamod34" />
          </div>
        </div>
        <div class="bet-item-wrap visibility" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </div>
      <!-- 1H CS -->
      <div class="handicap-col">
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 0</div>
            </div>

            <cstgftht :event="event" :score="'od10'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod10" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 0</div>
            </div>

            <cstgftht :event="event" :score="'od20'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod20" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 1</div>
            </div>

            <cstgftht :event="event" :score="'od21'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod21" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 0</div>
            </div>

            <cstgftht :event="event" :score="'od30'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod30" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;"><span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 1</div>
            </div>

            <cstgftht :event="event" :score="'od31'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod31" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 2</div>
            </div>
            <cstgftht :event="event" :score="'od32'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod32" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap col3 absolute" style="height: 35px !important;" :style="{ width: (widthColumn[1]*3) + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">{{ sportAllBetLang['ALL_BET.LBL_AOS'] }}</div>
            </div>

            <cstgftht :event="event" :score="'aos'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamodaos" />
          </div>
        </div>
      </div>
      <div class="handicap-col">
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 0</div>
            </div>

            <cstgftht :event="event" :score="'od00'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod00" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 1</div>
            </div>

            <cstgftht :event="event" :score="'od11'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod11" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 2</div>
            </div>

            <cstgftht :event="event" :score="'od22'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod22" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">3 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od33'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod33" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">

        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap visibility" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </div>
      <div class="handicap-col">
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 1</div>
            </div>

            <cstgftht :event="event" :score="'od01'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod01" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 2</div>
            </div>

            <cstgftht :event="event" :score="'od02'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod02" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 2</div>
            </div>

            <cstgftht :event="event" :score="'od12'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod12" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">0 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od03'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod03" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">1 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od13'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod13" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" :class="'bet-cs-'+firstHtPlyType">
            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
              <span class="handicap-more" style="display: none;">&nbsp;</span>
              <div class="handicap-value-text">2 - 3</div>
            </div>

            <cstgftht :event="event" :score="'od23'" :plyType="firstHtPlyType" :betType="bettype" :decimalNumber="1" ref="teamod23" />
          </div>
        </div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="bet-item-wrap visibility" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </div>
      <template v-if="isUnfold">
        <div class="handicap-col" v-if="widthColumn[3]==0">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
        <div class="handicap-col" v-if="widthColumn[3]<2">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
        <div class="handicap-col">
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    // allBetEvent: null,
    event: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    widthColumn:null,
    isUnfold:false
  },
  computed: {
    ...mapGetters([
      'mainMarketBet',
      'selectedShow',
      'moreBetLoading',
      'sportAllBetLang',
    ]),
  },
  data() {
    return {
      // bettype: (this.$store.getters.mainMarketBet.event_rb == 0 ? allBetMixin.data().csBetType : allBetMixin.data().rcsBetType),
      btypes: [allBetMixin.data().csBetType, allBetMixin.data().rcsBetType],
      show: true,
      mainMarketList: null,
      bettype: (this.event.rbinfo ? allBetMixin.data().rcsBetType : allBetMixin.data().csBetType),
    }
  },
  methods: {
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    addToMyMarket(plytyp, csBetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, csBetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
    },
  },
  beforeMount() {
    // var a = 'aaaa'
    this.mainMarketList = _.cloneDeep(this.$store.getters.eventAllBet)
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/moreBet-cs.vue